<div class="content__inner">
    <header class="content__title">
        <h1>{{ "shopitems.list.title" | translate }}</h1>
        <small>{{ "shopitems.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'SHOPITEMS.ADD'" (click)="addShopItem()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "shopitems.list.add" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'SHOPITEMS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "shopitems.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.name" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="materialNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.materialnumber" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.materialNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.category" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.getCategoryI18N() | translate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="inactive">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.inactive" | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <input type="checkbox" id="inactive{{ row._id }}" [(ngModel)]="row.inactive" (click)="onInactiveToggle(row)" [disabled]="!hasEditPermissions" />
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date: UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "shopitems.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date: UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="editShopItem(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'SHOPITEMS.EDIT'"></i>
                            <i (click)="deleteShopItem(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'SHOPITEMS.DELETE'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
